import React from "react";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";

const SurveyIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg width={width} height={height} fill="none" {...props}>
    <Path
      stroke={color}
      d="M4.083 5.833a.542.542 0 1 1-1.083 0 .542.542 0 0 1 1.083 0Z"
    />
    <Path
      fill={color}
      d="M3.542 11.042a1.042 1.042 0 1 0 0-2.084 1.042 1.042 0 0 0 0 2.084ZM3.542 15.208a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM16.717 8.958h-10.1c-.433 0-.784.439-.784.98v.124c0 .541.351.98.784.98h10.1c.432 0 .783-.439.783-.98v-.125c0-.54-.35-.979-.783-.979ZM16.717 13.125h-10.1c-.433 0-.784.438-.784.98v.124c0 .54.351.98.784.98h10.1c.432 0 .783-.44.783-.98v-.125c0-.54-.35-.979-.783-.979ZM16.717 4.792h-10.1c-.433 0-.784.438-.784.979v.125c0 .54.351.98.784.98h10.1c.432 0 .783-.44.783-.98V5.77c0-.54-.35-.98-.783-.98Z"
    />
  </Svg>
);

export default SurveyIcon;
